import Question from "../types/Question.interface";

const MUST_HAVE_VALUE = 1;

export const extractMustHaves = (questions: Question[]): Question[] => {
  const extractedMustHaves = questions.filter(
    (question) => question.priority === MUST_HAVE_VALUE
  );

  return extractedMustHaves;
};

export const extractShouldHaves = (questions: Question[]): Question[] => {
  const extractedShouldHaves = questions.filter(
    (question) => question.priority !== MUST_HAVE_VALUE
  );

  return extractedShouldHaves;
};
